export enum ValidationType {
	TEST_RESULT_MANUAL_INPUT = "TEST_RESULT_MANUAL_INPUT",
	GENERIC_MANUAL_INPUT = "GENERIC_MANUAL_INPUT",
	SINGLE_PHOTO = "SINGLE_PHOTO",
	MULTIPLE_PHOTOS = "MULTIPLE_PHOTOS",
	VIDEO = "VIDEO",
	FORM = "FORM",
	ATTENDANCE = "ATTENDANCE",
}

export interface EventResult {
	id: string;
	display: string;
	shortName?: string;
	displayColor?: string;
	allowForEntrySelection: boolean;
	allowForEditionWithOutPerm: boolean;
	validResult: boolean;
	disenrollmentJobStatus?: boolean;
	requireConfirmation?: boolean;
	missEntry?: boolean;
}

export interface EventKPI {
	name: string;
	url: string;
	active?: boolean;
	position?: number;
}

export interface SectionConfig {
	action: string;
	position: number;
	title: string;
	customStructure?: Record<string, unknown>;
}

export interface Event {
	_id: string;
	name: string;
	verificationType: "Manual" | "Automatic";
	validationType: ValidationType;
	requireMobileValidation?: boolean;
	eventResults?: EventResult[];
	dashboardKPIs?: EventKPI[];
	profileStatisticsKPIs?: EventKPI[];
	sectionConfig?: SectionConfig;
	createdAt: string;
	updatedAt: string;
}

export interface EventRequest {
	name: string;
	verificationType: "Manual" | "Automatic";
	validationType: ValidationType;
	requireMobileValidation?: boolean;
	eventResults?: EventResult[];
	dashboardKPIs?: EventKPI[];
	profileStatisticsKPIs?: EventKPI[];
	sectionConfig?: SectionConfig;
	createdBy?: string;
	updatedBy?: string;
}
